export default {
      id: "feuilleter-usage",
      viewBox: "0 0 50 50",
      url: "../dist/images/" + "sprite.svg#feuilleter-usage",
      toString: function () {
        return this.url;
      }
    }